import { buildPortalUrl } from "../../utils/url";

export const HERO_START_TRIAL_CTA = buildPortalUrl({ mode: "register", content: "hero_main_trial" });
